import WebServiceRequest from "../../../Api/WebServiceRequest";

class VirtualCategoryDeleteRequest extends WebServiceRequest {
  constructor(context) {
    super(context);
  }
  setId(id) {
    super.setTag("VirtualCategory/Delete?id=" + id);
  }
}
export default VirtualCategoryDeleteRequest;
